// extracted by mini-css-extract-plugin
var _1 = "Answer_answer__55c4d";
var _2 = "Answer_label__0c68f";
var _3 = "Answer_mask__e8009";
var _4 = "Answer_placeholder__b6f3d";
export { _1 as "answer", _2 as "label", _3 as "mask", _4 as "placeholder" }
